export default class WebsocketComputerLogs{
    url:string;
    websocket: WebSocket | null = null;

    constructor(url){
        this.url = url
    }

    connectWs() {
        this.websocket = new WebSocket(this.url);
        return this.websocket;
    }
}